export default __webpack_public_path__ + "static/media/fitmap.9ef1fd9e.svg";